import { render, staticRenderFns } from "./pc1.vue?vue&type=template&id=6b9f4a15&scoped=true&"
import script from "./pc1.vue?vue&type=script&lang=js&"
export * from "./pc1.vue?vue&type=script&lang=js&"
import style0 from "./pc1.vue?vue&type=style&index=0&id=6b9f4a15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f4a15",
  null
  
)

export default component.exports